import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { } from 'googlemaps';
import { MapsAPILoader } from '@agm/core';
import {} from '@types/googlemaps';
import {Post} from "../models/post.model";
import {Credentials} from "../models/credentials";
import {PublicationService} from "../nservices/publication.service";
import {LocalDataService} from "../services/local-data.service";
import { CredentialsService } from '../nservices/login/credentials.service';
import { SharedinfoService } from '../nservices/sharedinfo.service';
import { SinglePost } from '../nmodels/postbyuser.model';


@Component({
  selector: 'app-editpublication',
  templateUrl: './editpublication.component.html',
  styleUrls: ['./editpublication.component.css']
})
export class EditpublicationComponent implements OnInit {

  @ViewChild('search')
  public searchElement:ElementRef;

  //Hidden the maps landmarks default
  public whitoutPoints = [{
      "featureType": "poi",
      "elementType": "labels",
      "stylers": [{
          "visibility": "off"
        }]
      }
    ];


   // lat: number;
   // lng: number;
   searchControl: FormControl;
   // zoom: number;

   credentials?:Credentials;
   post?:SinglePost;
   oldTitle:string;

  constructor(private _publicationS:PublicationService,private _router: Router,
              private _credentialsS:CredentialsService,private _sharedinfoS:SharedinfoService) {

  if(!this._credentialsS.getCredentials()){
    this._router.navigate(['login']);
  }
  else if(this._credentialsS.getCredentials() && !this._sharedinfoS.getasParamPostByUSerModel()){
    this._router.navigate(['home']);
  }
  else if(this._credentialsS.getCredentials() && this._sharedinfoS.getasParamPostByUSerModel()){
    let publication = this._sharedinfoS.getasParamPostByUSerModel();
    this.post = publication.posts[0];
    this._sharedinfoS.setasParamPublication(null);
  }
    this.oldTitle = this.post.title;
  }

  ngOnInit() {
  }


  savePublication(){
    if (confirm("Estas seguro de editar la publicación "+this.oldTitle+"?")) {
      if(this._credentialsS.getCredentials()){
        this._publicationS.editPublication(this.post.id,this.post.title,this.post.comment)
                        .subscribe(resp => {
                          console.log("post edited " + this.post.id);
                          this._router.navigate(['mypublications']);
                        })
      }
      else{
        alert("Parece que tu sesion ha caducado, te invitamos a iniciar sesion nuevamente para continuar")
      }
    }
  }
























}



// WEBPACK FOOTER //
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/editpublication/editpublication.component.ts